import './aboutPage.css'

const AboutPage = () => {
  return (
    <>
      <h1>About</h1>
      <div className="about-wrapper">This is sample about page</div>
    </>
  )
}
export default AboutPage
